import { withJsonFormsControlProps } from '@jsonforms/react';
import { ControlProps } from '@jsonforms/core';
import { WithInput } from '@jsonforms/material-renderers';
import OTPInput from '../components/OTPInput';

const ControlOTPInput = (props: ControlProps & WithInput) => {
  return(
    <OTPInput
    {...props}
   />)
  }

export default withJsonFormsControlProps(ControlOTPInput);